import React from "react";
import styled from "styled-components";

const Table = styled.table`
    table-layout: fixed;
    border-collapse: collapse;
    border-right: 0;
    td {
        border: 1px solid #000;
        width: 25px;
        max-width: 25px;
    }
    tr.cron td {
        text-align: center;
        border-top: 0;
    }
    tr:not(.cron) {
        vertical-align: top;
        & td:first-child {
            border-bottom: 0;
        }
        & td {
            padding: 5px;
            & p {
                white-space: nowrap;
                overflow: visible;
                width: 100%;
                font-size: 14px;
            }
        }
    }
`;

const Table2 = styled.table`
    border-spacing: 0;
    border-collapse: collapse;
    & td {
        border-top: 1px solid #333 !important;
        border-bottom: 1px solid #333 !important;
        border-left: 0 !important;
        border-right: 0 !important;
        padding: 2px 5px !important;
        text-align: left;
    }
    & p.sign { text-align: center; }
`;

const Wrap = styled.div`
    width: 500px;
    max-width: 800px;
    cursor: initial;
`;
const Cron = () => {
    return (
        <Wrap>
            <Table>
                <tbody>
                    <tr>
                        <td rowSpan={6} style={{ borderRight: 0 }}>
                            <p>Second [ 0-59 ]</p>
                        </td>
                        <td colSpan={5} style={{ borderLeft: 0, borderRight: 0 }}>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={5} style={{ borderRight: 0 }}>
                            <p>Minute [ 0-59 ]</p>
                        </td>
                        <td colSpan={4} style={{ borderLeft: 0, borderRight: 0 }}>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={4} style={{ borderRight: 0 }}>
                            <p>Hour [ 0-23 ]</p>
                        </td>
                        <td colSpan={3} style={{ borderLeft: 0, borderRight: 0 }}>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={3} style={{ borderRight: 0 }}>
                            <p>Day of the month [ 1-31 ]</p>
                        </td>
                        <td colSpan={2} style={{ borderLeft: 0, borderRight: 0 }}>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan={2} style={{ borderRight: 0 }}>
                            <p>Month [ 1-12 ]</p>
                        </td>
                        <td colSpan={1} style={{ borderLeft: 0, borderRight: 0 }}>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td style={{ borderRight: 0 }}>
                            <p>Day of the week [ 1-7 ]</p>
                        </td>
                    </tr>
                    <tr className={`cron`}>
                        <td>*</td>
                        <td>*</td>
                        <td>*</td>
                        <td>*</td>
                        <td>*</td>
                        <td>*</td>
                    </tr>
                </tbody>
            </Table>
            <div style={{ fontSize: "12px", marginTop: "10px" }}>
                <Table2>
                    <colgroup>
                    <col width="80px"></col></colgroup>
                    <tbody>
                        <tr>
                            <td style={{ width: "max-content" }}>
                                <p className={`sign`}>*</p>(all values)
                            </td>
                            <td>
                                Selects all values within a field.
                                <br />
                                For example, * in the minute field selects "every minute".
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className={`sign`}>-</p>(range)
                            </td>
                            <td>
                                Used to specify ranges.
                                <br />
                                For example, 10-12 in the hour field selects the hours 10, 11 and 12.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className={`sign`}>,</p>(comma)
                            </td>
                            <td>
                                Used to specify additional values.
                                <br />
                                For example, 2,3,5 in the day-of-week field means the days Monday, Wednesday, and Friday.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p className={`sign`}>/</p>(forward slash)
                            </td>
                            <td>
                                Used to specify increments.
                                <br />
                                For example, 0/14 in the seconds field means the seconds 0, 14, 28, and 42; and 2/14 in the
                                seconds field means the seconds 2, 16, 30, and 44.
                            </td>
                        </tr>
                    </tbody>
                </Table2>
                <p style={{ textAlign: "left", margin: "5px 0" }}>Examples:</p>
                <Table2>
                    <tbody>
                        <tr>
                            <td>0 0 12 * * *</td>
                            <td>12 PM (noon) every day.</td>
                        </tr>
                        <tr>
                            <td>0 15 10 * * *</td>
                            <td>10:15 AM every day.</td>
                        </tr>
                        <tr>
                            <td>0 0-5 14 * * *</td>
                            <td>Every minute starting at 2 PM and ending at 2:05 PM, every day.</td>
                        </tr>
                        <tr>
                            <td>0 15 10 15 * ?</td>
                            <td>10:15 AM on the 15th day of every month.</td>
                        </tr>
                        <tr>
                            <td>0 15 10 ? * 2-6</td>
                            <td>10:15 AM every Monday, Tuesday, Wednesday, Thursday and Friday.</td>
                        </tr>
                    </tbody>
                </Table2>
            </div>
        </Wrap>
    );
};

export default Cron;
